module.exports = __webpack_public_path__ + "static/media/home_ak.988e038f.png";